import React from 'react';

import './RecurringBuyFundEditor.scss';

import { START_DATE_TOOL_TIP } from '../../../redux/modules/modals/modals.module';

const DayGrid = (props) => {
  const {
    limitText,
    openModal,
    onSelect,
    selectableDays,
    selectAll,
    SelectionGrid,
    selectedOptions,
    selectLimit,
  } = props;

  function showStartDateToolTip() {
    openModal(START_DATE_TOOL_TIP);
  }

  return (
    <SelectionGrid
      id="day-chart"
      btnSize={40}
      phoneColNum={5}
      options={selectableDays}
      onSelect={onSelect}
      selectAll={selectAll}
      selectedOptions={selectedOptions}
      title="Date"
      selectLimit={selectLimit}
      limitText={limitText}
      footer={
        <div className="rb-fund-editor-disclaimer-txt">
          <a className="rb-fund-editor-link" onClick={showStartDateToolTip}>
            View important details
          </a>{' '}
          about start dates, including weekdays and holidays.
        </div>
      }
    />
  );
};

export default DayGrid;
